
      var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7.072,
  y: 13.352,
  width: 32.214,
  height: 22.786,
  rx: 3.143,
  fill: "var(--theme-bright, #e3d2e9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.075 11v22a2.75 2.75 0 0 0 2.75 2.75h27.5c.76 0 1.375-.616 1.375-1.375v-19.25c0-.76-.615-1.375-1.375-1.375h-27.5A2.75 2.75 0 0 1 7.075 11v0a2.75 2.75 0 0 1 2.75-2.75H33.2",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.063,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31.138,
  cy: 24.75,
  r: 2.063,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"7.072\" y=\"13.352\" width=\"32.214\" height=\"22.786\" rx=\"3.143\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n    <path d=\"M7.075 11v22a2.75 2.75 0 0 0 2.75 2.75h27.5c.76 0 1.375-.616 1.375-1.375v-19.25c0-.76-.615-1.375-1.375-1.375h-27.5A2.75 2.75 0 0 1 7.075 11v0a2.75 2.75 0 0 1 2.75-2.75H33.2\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.063\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"31.138\" cy=\"24.75\" r=\"2.063\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wallet.34e90f176e9008f8af686757c6504e31.svg"),
        {
          React: SvgWallet,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      